/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Documents } from './Documents';
import {
    DocumentsFromJSON,
    DocumentsFromJSONTyped,
    DocumentsToJSON,
    DocumentsToJSONTyped,
} from './Documents';

/**
 * 
 * @export
 * @interface DocumentRequest
 */
export interface DocumentRequest {
    /**
     * 
     * @type {string}
     * @memberof DocumentRequest
     */
    offeringId?: string;
    /**
     * 
     * @type {Array<Documents>}
     * @memberof DocumentRequest
     */
    documents?: Array<Documents>;
}

/**
 * Check if a given object implements the DocumentRequest interface.
 */
export function instanceOfDocumentRequest(value: object): value is DocumentRequest {
    return true;
}

export function DocumentRequestFromJSON(json: any): DocumentRequest {
    return DocumentRequestFromJSONTyped(json, false);
}

export function DocumentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'offeringId': json['offeringId'] == null ? undefined : json['offeringId'],
        'documents': json['documents'] == null ? undefined : ((json['documents'] as Array<any>).map(DocumentsFromJSON)),
    };
}

export function DocumentRequestToJSON(json: any): DocumentRequest {
    return DocumentRequestToJSONTyped(json, false);
}

export function DocumentRequestToJSONTyped(value?: DocumentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'offeringId': value['offeringId'],
        'documents': value['documents'] == null ? undefined : ((value['documents'] as Array<any>).map(DocumentsToJSON)),
    };
}

